import React, { useEffect, useState } from "react";
import { fetchStockists } from "../lib/api";
import { MapPin, Clock, Phone } from "lucide-react";
import { JsonLd, localBusinessSchema } from "../components/JsonLd";

export default function Stockists() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetchStockists().then(setItems).catch(() => {});
    }, []);

    const flagships = items.filter((s) => s.flagship);
    const partners = items.filter((s) => !s.flagship);

    return (
        <div data-testid="stockists-page" className="pt-28">
            {items.map((s) => (
                <JsonLd key={`ld-${s.city}-${s.name}`} data={localBusinessSchema(s)} />
            ))}
            <section className="container-rail pb-12 border-b border-white/5">
                <div className="text-overline text-[#A3A3A3] mb-4">N° 06 · Stockists</div>
                <h1 className="text-display text-5xl sm:text-6xl md:text-7xl leading-[0.92]">
                    Where to find <span className="text-display-italic">the work</span>.
                </h1>
                <p className="text-[#A3A3A3] mt-6 max-w-xl leading-relaxed">
                    Three flagship rooms and a handful of carefully chosen partners across the world.
                </p>
            </section>

            {flagships.length > 0 && (
                <section className="container-rail py-16">
                    <div className="text-overline text-[#A3A3A3] mb-8">Flagship</div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {flagships.map((s) => (
                            <StoreCard key={s.city} store={s} flagship />
                        ))}
                    </div>
                </section>
            )}

            {partners.length > 0 && (
                <section className="container-rail py-16 border-t border-white/5">
                    <div className="text-overline text-[#A3A3A3] mb-8">Selected Partners</div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {partners.map((s) => (
                            <StoreCard key={`${s.city}-${s.name}`} store={s} />
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
}

const StoreCard = ({ store, flagship = false }) => (
    <div
        data-testid={`stockist-${store.city.toLowerCase()}`}
        className={`border p-6 sm:p-8 ${flagship ? "border-white/20 bg-[#111]" : "border-white/[0.08] bg-[#0E0E0E]"} hover:border-white/40 transition-colors`}
    >
        <div className="text-overline text-[#A3A3A3] mb-2">{store.country}</div>
        <h3 className="text-display text-3xl sm:text-4xl leading-tight">{store.city}</h3>
        <div className="text-brutal text-xs mt-1.5 text-[#A3A3A3]">{store.name}</div>
        {flagship && (
            <span className="inline-block mt-3 px-2 py-1 text-[9px] tracking-[0.22em] uppercase text-[#0C0C0C] bg-[#EDEDE6] font-display">
                Flagship
            </span>
        )}
        <div className="hairline my-5" />
        <ul className="space-y-3 text-sm text-[#D6D6CC]">
            <li className="flex gap-3">
                <MapPin className="h-4 w-4 text-[#A3A3A3] shrink-0 mt-0.5" strokeWidth={1.3} />
                <span>{store.address}</span>
            </li>
            <li className="flex gap-3">
                <Clock className="h-4 w-4 text-[#A3A3A3] shrink-0 mt-0.5" strokeWidth={1.3} />
                <span>{store.hours}</span>
            </li>
            <li className="flex gap-3">
                <Phone className="h-4 w-4 text-[#A3A3A3] shrink-0 mt-0.5" strokeWidth={1.3} />
                <span>{store.phone}</span>
            </li>
        </ul>
    </div>
);
